import { useEffect } from 'react';

function setMeta(attr, attrVal, content) {
  let el = document.querySelector(`meta[${attr}="${attrVal}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, attrVal);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}

function setCanonical(href) {
  let el = document.querySelector('link[rel="canonical"]');
  if (!el) {
    el = document.createElement('link');
    el.setAttribute('rel', 'canonical');
    document.head.appendChild(el);
  }
  el.setAttribute('href', href);
}

export function usePageSeo({ title, description, canonical, ogTitle, ogDescription, ogUrl, ogType, ogImage, twitterCard, noindex }) {
  useEffect(() => {
    document.title = title;
    if (description) setMeta('name', 'description', description);
    if (canonical) setCanonical(canonical);
    if (ogTitle) setMeta('property', 'og:title', ogTitle);
    if (ogDescription) setMeta('property', 'og:description', ogDescription);
    if (ogUrl) setMeta('property', 'og:url', ogUrl);
    if (ogType) setMeta('property', 'og:type', ogType || 'website');
    if (ogImage) setMeta('property', 'og:image', ogImage);
    if (twitterCard) setMeta('name', 'twitter:card', twitterCard || 'summary');
    if (ogTitle) setMeta('name', 'twitter:title', ogTitle);
    if (ogDescription) setMeta('name', 'twitter:description', ogDescription);
    if (noindex) {
      setMeta('name', 'robots', 'noindex');
    } else {
      const robots = document.querySelector('meta[name="robots"]');
      if (robots) robots.remove();
    }
  }, [title, description, canonical, ogTitle, ogDescription, ogUrl, ogType, ogImage, twitterCard, noindex]);
}
